import { render, staticRenderFns } from "./singleCardTransferRecord.vue?vue&type=template&id=51718e47&scoped=true"
import script from "./singleCardTransferRecord.vue?vue&type=script&lang=ts"
export * from "./singleCardTransferRecord.vue?vue&type=script&lang=ts"
import style0 from "./singleCardTransferRecord.vue?vue&type=style&index=0&id=51718e47&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51718e47",
  null
  
)

export default component.exports